import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';

import { MODULE_ROUTES } from '@common/constants/module-routes.const';

import { AppLoaderNavigationService } from '../services/app-loader-navigation.service';

export const appLoaderGuard: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> => {
  const appLoaderNavigationService = inject(AppLoaderNavigationService);
  const router = inject(Router);
  const code = route.paramMap.get('code');

  return appLoaderNavigationService.resolveNavigationItem(code).pipe(
    map(navigationItem => {
      // Only allow activation if navigation item exists
      if (navigationItem === null) {
        return router.createUrlTree([`/${MODULE_ROUTES.MAIN}`, MODULE_ROUTES.NO_ACCESS]);
      }
      return true;
    })
  );
};
